import { Modal } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { useMutation } from '@tanstack/react-query';
import { postCreateAccessRequest } from '../../../services/explorer/postCreateAccessRequest';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  companyUuid: string;
  remainingAccessRequestsTickets: number;
  onSuccess: () => void;
}

export const RenewAccessRequestModal = ({
  isOpen,
  onClose,
  companyUuid,
  remainingAccessRequestsTickets,
  onSuccess,
}: Props) => {
  const { t } = useTranslation();

  const { mutate, isPending } = useMutation({
    mutationFn: () => postCreateAccessRequest({ uuid: companyUuid }),
    onSuccess,
  });

  return (
    <Modal
      title={t('renewAccessRequest.modal.title')}
      text={t('renewAccessRequest.modal.title').replace(
        '{{remainingAccessRequestsTickets}}',
        remainingAccessRequestsTickets.toString(),
      )}
      isOpen={isOpen}
      onClose={onClose}
      labelBtnConfirm={t('common.renew')}
      onClickConfirm={mutate}
      isLoadingConfirmBtn={isPending}
      labelBtnClose={t('common.cancel')}
    />
  );
};
